// src/pages/About.tsx
import { Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Lists } from '../../components/common/Lists';
import TableComponent from '../../components/common/Tables';
import { useAppDispatch } from '../../hooks/hooks';
import { useGetRolesQuery } from '../../hooks/useGetRolesQuery';
import { setRoleData } from '../../redux/slices/users/role';
import { removeRole } from '../../services/user/removeRole';
import { RoleType } from '../../types/Role';
import { routes } from '../../routes';
import { ConfirmAlertDialog } from '../../components/common/ConfirmAlertDialog';
import { getAllStaticRoles, staticRoles } from '../../staticRoles';

const columnNamesMap: { [key: string]: string } = {
    name: 'Perfil',
};

export const Roles = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const [deleteItem, setDeleteItem] = useState<RoleType | null>(null);

    const { data, status } = useGetRolesQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationRemoveItem = useMutation(removeRole, {
        onSuccess: () => {
            queryClient.invalidateQueries('roles-pagination');
            toast.success('Perfil eliminado com sucesso');
        },
        onError: () => {
            toast.error("Erro ao eliminar o perfil.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleCreateItem = (event: any): void => {
        navigate(routes.createRole)
    }

    const handleEditRole = (role: RoleType) => {
        const staticRoles = getAllStaticRoles();
         if (staticRoles.includes(role.name!)) {
             toast.error('Não pode ser editada. Contacte o administrador');
             return;
         }
         dispatch(setRoleData(role));
         navigate(routes.updateRole)
    };

    const handleRemove = async (id: string) => {
        mutationRemoveItem.mutate(id);
    };
    const openDeleteDialog = (role: RoleType) => {
        const staticRoles = getAllStaticRoles();
        if (staticRoles.includes(role.name!)) {
            toast.error('Não pode ser apagada. Contacte o administrador');
            return;
        }
        setDeleteItem(role);
    };  

    const confirmDelete = async () => {
        if (deleteItem) {
            await handleRemove(deleteItem.id!)
        }
    };
    const options = data?.items.map((role: any) => [
        {
            label: 'Editar',
            onClick: (role: RoleType) => handleEditRole(role),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(role),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <>
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={['name']}
                    items={data?.items}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleCreateItem}
        />
           <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Eliminar perfil"
                description="Esta operação é irreversível."
                confirmLabel="Eliminar"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
};

export default Roles;